import React, { FunctionComponent, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../common/models/store/IAppState';
import { IBindingCallback1 } from '../../../../common/models/callback';
import CustomPopover from '../../../../components/CustomPopover';
import { CandidateFilterType } from '../../../../common/enums/CandidateFilterType';
import { CandidateCounts } from '../../../../common/models/candidate/CandidateCounts';
import { map } from 'ramda';
import { sidebarItems } from './utils';
import RegularButton from '../../../../components/RegularButton';
import Icon from '../../../../components/Icon';
import CheckboxFilter from '../../../../components/CheckboxFilter';
import styles from './styles.module.scss';
import { concat } from '../../../../common/helpers/arrayHelper';

interface IStatusDropdownProps {
  filterCounters: CandidateCounts | undefined;
  onChange: IBindingCallback1<CandidateFilterType[]>;
  disabled?: boolean;
}

const FilterDropdown: FunctionComponent<IStatusDropdownProps> = ({ onChange, filterCounters, disabled = false }) => {
  const [selectedFilters, setSelectedFilters] = useState([] as string[]);

  const onSelect = (ids: string[]) => {
    setSelectedFilters(ids);
    const enumIds = ids as CandidateFilterType[];
    onChange(enumIds);
  };

  const sidebarData = map(p => ({
    ...p,
    count: filterCounters ? filterCounters[p.id as CandidateFilterType] : 0,
    children: p.children
      ? map(c => ({
        ...c,
        count: filterCounters ? filterCounters[c?.id as CandidateFilterType] : 0
      }), p.children)
      : null
  }), sidebarItems);

  useEffect(() => {
    if (!selectedFilters.length) {
      setSelectedFilters([sidebarData[0].id]);
      onChange([sidebarData[0].id] as CandidateFilterType[]);
    }
  }, [selectedFilters]);

  const Trigger = () => (
    <RegularButton
      variant="secondary"
      disabled={disabled}
      icon={<Icon icon="filter" className={concat(disabled ? styles.disabledIcon : '')} />}
      textIntlId="candidateHeader.filterCandidates"
      defaultMessage="Filter candidates"
    />
  );

  const Body = () => (
    <div className={styles.filter}>
      <CheckboxFilter
        items={sidebarData}
        onChange={onSelect}
        selected={selectedFilters}
      />
    </div>
  );

  return (
    <CustomPopover
      showArrow
      placement="bottom-start"
      rootClose
      trigger={<Trigger />}
    >
      <Body />
    </CustomPopover>
  );
};

const mapStateToProps = ({
  positionProfile: {
    filterCounters
  }
}: IAppState) => ({ filterCounters });

export default connect(mapStateToProps)(FilterDropdown);
